<script>
	// From Lucide
	import { Trash2 } from 'lucide-svelte';

	export let iconClass = '';
</script>

<Trash2 class={iconClass} />
